import React from "react";
import contact from "../../data/contact.json";
import "./stickyCtas.css";

// Site-wide fixed right-edge action rail, shown on every page:
//  - "Apply Now"   -> external admissions landing site (new tab)
//  - "Enquire Now" -> /enquire in a new tab, which hosts the NoPaperForms
//    enquiry form (components/NpfEnquiryWidget).
const StickyCtas = () => {
  return (
    <div className="sticky-cta" aria-label="Quick actions">
      <a
        className="sticky-cta__btn sticky-cta__btn--apply"
        href={contact.applyUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 3h7v7m0-7L10 14M19 14v5a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h5" />
        </svg>
        Apply Now
      </a>
      <a
        className="sticky-cta__btn sticky-cta__btn--enquire"
        href="/enquire"
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 10h.01M12 10h.01M16 10h.01M21 12a8 8 0 01-8 8H7l-4 3V12a8 8 0 018-8h2a8 8 0 016 8z" />
        </svg>
        Enquire Now
      </a>
    </div>
  );
};

export default StickyCtas;
